import { OnInit } from "@angular/core";
import { CouponService } from "app/core/services/coupon.service";
import { BusinessCoupon } from "app/public/model/BusinessCoupon";
import { Coupon } from "app/public/model/coupon.model";
import { LocalizationService } from "app/shared/localization/localization.service";
import { FieldTypes } from "app/shared/model/enums";
import { CommonService } from "app/shared/services/common.service";
import { BehaviorSubject, map, Observable, Subject, switchMapTo, tap } from "rxjs";

export abstract class BaseBusinessCoupon {
    request: { Filter: { CreatedAt: { From: Date; To: Date; },isActive:boolean }; Paging: any; }
    businessCoupons$: Observable<BusinessCoupon[]>
    columns: { field: string; headerTranslate: string; type?: FieldTypes; width?: string; }[]
    freeSearch: string
    _startDate: Date;
    _endDate: Date;
    isActive:boolean=true
    numRowsInPage=100;
    status:boolean;
    selectedStatus:boolean;
    totalRecords: number;
    returnTotalRecords=false;
     loadCouponsEvent$ =   new BehaviorSubject(true) ;
     translatedStatusOptions: { label: string; value: boolean }[] = [];
    statusOptions = [
        { label: 'BUSINESS_COUPON.ACTIVE', value:true },
        { label: 'BUSINESS_COUPON.INACTIVE', value: false}
      ];
    get startDate() {
        return this._startDate;
      }
      set startDate(value) {
        if (value !== this._startDate) {
          this._startDate = value;
          this.filterCreatedDate()
        }
      }
      get endDate() {
        return this._endDate;
      }
      set endDate(value) {
        if (value !== this._endDate) {
          this._endDate = value;
          this.filterCreatedDate()
        }
      }
    constructor(public couponService: CouponService,public localizationService: LocalizationService,public commonService: CommonService, ) {

    }
 
    init(): void {
        this.commonService.changeCurrentPageHeader(this.localizationService.Translate('BUSINESS_CUPON.TITTLE')) ;
         this.initColumns();
         this.createRequest();
         this.translateStatusOptions()
    }
    loadBusinessCoupons(): void {
        if (!this.businessCoupons$) {
            this.initLoadBusinessCouponsObservable();
        } else {
            this.loadCouponsEvent$.next(true);
        }
    }
    initLoadBusinessCouponsObservable(): void {        
        this.businessCoupons$ = this.loadCouponsEvent$.pipe(
            switchMapTo(
                this.couponService.getCoupons(this.request).pipe(
                    tap(res => {
                        this.totalRecords = res.TotalCount;
                        if(this.totalRecords)
                          this.returnTotalRecords = true;
                    }),
                    map(res => res.BuisnessCoupons)
                )
            )
        );
    }
    createRequest(pageNo?: number) {
        this.request = {
          Paging: {
            PageNo: pageNo? pageNo : 1,
            NumberRowsInPage: this.numRowsInPage
          },
          Filter: {
            CreatedAt: {
              From: this.startDate,
              To: this.endDate,
            },
            isActive:this.isActive
          }
        }
        if(pageNo){
           this.initLoadBusinessCouponsObservable();
        }
      }
    private initColumns() {
        this.columns = [
            {
                field:"iconUrl",
                headerTranslate:"",
                type:FieldTypes.icon
            },
            {
                field: 'name',
                headerTranslate: 'BUSINESS_COUPON.TEXT',
            },
            {
                field: 'startDate',
                headerTranslate: 'BUSINESS_COUPON.START_DATE',
                type: FieldTypes.fullDate,

            },
            {
                field: 'endDate',
                headerTranslate: 'BUSINESS_COUPON.END_DATE',
                type: FieldTypes.fullDate,

            },
            {
                field: 'type',
                headerTranslate: 'BUSINESS_COUPON.TYPE',
            },
            {
                field: 'isActive',
                headerTranslate: 'BUSINESS_COUPON.IS_ACTIVE',
                type:FieldTypes.bool
            },
            // {
            //     field: 'isDisplay',
            //     headerTranslate: 'BUSINESS_COUPON.IS_DISPLAY_IN_SPIN',
            //     type:FieldTypes.bool

            // },
            {
                field: 'link',
                headerTranslate: 'BUSINESS_COUPON.REDIRECT_LINK',
                type:FieldTypes.link
            },
            {
              field:'customerName',
              headerTranslate:'BUSINESS_COUPON.CUSTOMER_NAME'
            },
            {field:'customerEmail',
              headerTranslate:'BUSINESS_COUPON.CUSTOMER_EMAIL'
            }

        ]
    }
    filterCreatedDate() {
        this.request.Filter.CreatedAt = {
          From: this._startDate ? this._startDate : null,
          To: this.endDate ? this.endDate : null
        }
         this.loadBusinessCoupons()
      }
      filterStatus(){
        this.request.Filter.isActive=this.selectedStatus                
        this.loadBusinessCoupons()        
      }
      translateStatusOptions(): void {
        this.translatedStatusOptions = this.statusOptions.map(option => ({
          label: this.localizationService.Translate(option.label), 
          value: option.value
        }));
      }
}